import React from 'react'
import { Col, Row, VertTypography } from "@vertem-core/vertice-ds";
import FallbackImage from 'react-image-fallback'
import PropTypes from "prop-types";
import 'Assets/styles/default/components/RatingProducts/RatingProducts.less'
const RatingProduct = ({ productImg, productName, seller }) => {
    return (
        <div className="margin-x-none padding-bottom-small" style={{ display: 'flex', maxWidth: '650px' }}>
            <div className={'padding-x-none'} style={{ flex: '0 0 8rem', textAlign: 'right', marginRight: '5px' }}>
                <figure className="RatingProduct-figure">
                    <FallbackImage src={productImg || ''} />
                </figure>
            </div>
            <div style={{ display: 'flex', flex: '1', alignItems: 'center' }}>
                <VertTypography.Title level={3} className='margin-y-none'>
                    {productName || 'produto não informado.'}<br />
                    {seller || ''}
                </VertTypography.Title>
            </div>
        </div>

    )
}

RatingProduct.propTypes = {
    productImg: PropTypes.string,
    productName: PropTypes.string,
    seller: PropTypes.string,
}

export default RatingProduct;
